import React from "react";
import SnackbarContent from "../../components/Snackbar/SnackbarContent";
import { showToast, getIcon } from "../slices/toast";

// react-notification-system's addNotification() calls setState on a mounted
// component. Calling it from inside the showToast reducer (as this used to
// do) runs that setState synchronously while Redux is still dispatching,
// which can crash with "Reducers may not dispatch actions" / "may not
// unsubscribe from a store listener while the reducer is executing" if a
// component happens to unmount in the same tick (e.g. right after a booking
// modal closes). Running it here, after next(action) has returned, ensures
// the reducer has already finished and Redux is no longer mid-dispatch.
const toastMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action.type === showToast.type) {
    const { notification } = store.getState().toasts;
    const { message, type, autoDismiss, notShowIcon } = action.payload;
    notification &&
      notification.addNotification({
        title: null,
        message: null,
        level: "info",
        dismissible: "click",
        autoDismiss: autoDismiss ? autoDismiss : 3,
        children: (
          <SnackbarContent
            color={type || "primary"}
            icon={notShowIcon ? undefined : getIcon(type)}
            message={message}
            closeNotification={() => {}}
            close
          />
        ),
      });
  }

  return result;
};

export default toastMiddleware;
